import config from './config/project'

// const Raven = process.env.IS_BROWSER ? null : require('raven')
let logger
if (process.env.IS_BROWSER) {
  // IE9 일부 버전에서, console 호출 시점에 console 이 정의되지 않았을 수 있음. 그에 대한 방어 로직. https://oss.navercorp.com/bizServiceLab/random/issues/381
  const c: any = {}
  c.log = c.warn = c.debug = c.info = c.error = c.time = c.dir = c.profile = c.clear = c.exception = c.trace = c.assert = function(
    s,
  ) {}
  logger = (window && window.console) || c
} else {
  logger = require('server/logger').default
}

const trace: Console['trace'] = (message, ...args) => {
  process.env.NODE_ENV !== 'production' && logger.trace(message, ...args)
}

const debug: Console['debug'] = (message, ...args) => {
  process.env.NODE_ENV !== 'production' && logger.debug(message, ...args)
}

const info: Console['info'] = (message, ...args) => {
  process.env.NODE_ENV !== 'production' && logger.info(message, ...args)
}

const warn: Console['warn'] = (message, ...args) => {
  logger.warn(message, ...args)
}

const error: Console['error'] = (message, ...args) => {
  let errors: Error[] = [message, ...args].filter(e => {
    return e instanceof Error
  })

  if (!(message instanceof Error) && errors && errors.length > 0) {
    errors[0].message = `message ${message} > ${errors[0].message}`
  } else {
    errors = [new Error(message)]
  }

  // try {
  //   !process.env.IS_BROWSER && Raven.captureException(errors[0], { fingerprint: [...args] })
  // } catch (e) {}

  logger.error(message, ...args)
}

export default {
  trace,
  debug,
  info,
  warn,
  error,
}
